import { render, staticRenderFns } from "./cpfCnpj.vue?vue&type=template&id=36b26fb6"
import script from "./cpfCnpj.ts?vue&type=script&lang=js&external"
export * from "./cpfCnpj.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b26fb6')) {
      api.createRecord('36b26fb6', component.options)
    } else {
      api.reload('36b26fb6', component.options)
    }
    module.hot.accept("./cpfCnpj.vue?vue&type=template&id=36b26fb6", function () {
      api.rerender('36b26fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/cpfCnpj.vue"
export default component.exports